// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1PsBl","header":"PatientBlock_header__2ThUf","label":"PatientBlock_label__zK6OW","option":"PatientBlock_option__3OQU_"};